import {BrowserRouter as Router, Switch, Route} from "react-router-dom";
import VideoChat from "./VideoChat/VideoChat";
import Header from "./Header/Header";
import Dashboard from "./Dashboard/Dashboard";
import Faq from "./Faq/Faq";

const App = () => {
  return(
      <>
        <Router forceRefresh={true}>
          <Header />
          <Switch>
            <Route exact path="/" component={Dashboard}>
            </Route>
            <Route exact path="/call/:username" component={VideoChat}>
            </Route>
              <Route exact path="/faq" component={Faq}>
              </Route>
          </Switch>
        </Router>
      </>
  )
}

export default App;